export enum AppointmentStatusNotificationType {
  CARD = 'CARD',
  POP_UP = 'POP_UP',
}
